import { Container, Shimmer, Spacer } from '@/src/ct-design/lib'

const TravellerChipsLoader = () => {
    return (
        <Container className='flex flex-middle mb-2'>
            <Shimmer height='38px' width='101px' borderRadius='8px' />
            <Spacer className='mr-2' />
            <Shimmer height='38px' width='101px' borderRadius='8px' />
            <Spacer className='mr-2' />
            <Shimmer height='38px' width='101px' borderRadius='8px' />
        </Container>
    )
}

export default TravellerChipsLoader
